module.exports = "<i class=\"expand right material-icons\">{{ (active$ | async) ? 'expand_less' : 'expand_more' }}</i>\n<ng-content></ng-content>\n"